import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await register(email, password, name);
      toast.success(`Welcome to the house, ${u.name}`);
      navigate("/rooms");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-2 gap-16 items-center">
      <div className="hidden md:block">
        <span className="hanko text-primary text-4xl">結</span>
        <h1 className="font-serif font-light text-5xl lg:text-6xl tracking-tighter mt-6 leading-[0.95]">
          Take up<br />the brush.
        </h1>
        <p className="mt-6 text-muted-foreground max-w-sm">
          Choose the name your verses will carry, and join a lineage of linked poetry.
        </p>
      </div>

      <div className="max-w-md w-full">
        <h2 className="font-serif text-3xl mb-8">Join the house</h2>
        <form onSubmit={submit} className="space-y-6" data-testid="register-form">
          <div>
            <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">Poet name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              data-testid="register-name"
              className="w-full bg-transparent border border-border px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="register-email"
              className="w-full bg-transparent border border-border px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="register-password"
              className="w-full bg-transparent border border-border px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            />
          </div>
          {error && (
            <p data-testid="register-error" className="text-sm text-primary">{error}</p>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit"
            className="w-full bg-primary text-primary-foreground py-3 text-sm tracking-wide hover:-translate-y-0.5 transition-transform disabled:opacity-50"
          >
            {busy ? "Joining…" : "Join"}
          </button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">
          Already a member?{" "}
          <Link to="/login" data-testid="link-login" className="text-primary border-b border-primary/40">
            Enter
          </Link>
        </p>
      </div>
    </div>
  );
}
